import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { Unit } from "../..";

@Injectable()
export class UnitService extends BaseDataService<Unit> {
  constructor(http: HttpService) {
    super(http, "unit");
  }

  createInstance(options: any): Unit {
    return new Unit(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
